export default __webpack_public_path__ + "static/media/close-icon.b1d72681.svg";